// extracted by mini-css-extract-plugin
export default {"main-div":"Location_main-div__ruAW3"};